import CommissionRateItem from '../../../Domain/CommissionRateItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CommissionRateService from '../../../Services/CommissionRateService';

export default class EditCommissionRateWindowDescription {
  static titleForCreate = 'Add New Commission Rate';
  static titleForEdit = (editedItem) => `Edit Commission Rate (#${editedItem.CommissionRateId})`;
  static itemType = CommissionRateItem;
  static serviceFunction = CommissionRateService.UpsertItem;

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CommissionYearPeriod',
          label: 'Year',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditCommissionRateWindowDescription.getCommissionYearOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !!item.CommissionRateId,
        },
        {
          fieldName: 'Rate',
          label: 'Rate',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'StartedOn',
          label: 'Start Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => !!item.CommissionRateId,
        },
        {
          fieldName: 'CurrencyId',
          label: 'Currency',
          className: 'col-6',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  static getCommissionYearOptions() {
    //If changes are made here, EditServiceDescription.getCommissionYearOptions should be updated accordingly
    return [
      { value: null, label: 'Choose one...' },
      { value: 1, label: 'Year 1' },
      { value: 2, label: 'Year 2' },
    ];
  }
}
